import React, { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import CookieConsent from "@/components/CookieConsent";
import PixelRouteTracker from "@/components/PixelRouteTracker";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Science from "@/pages/Science";
import Book from "@/pages/Book";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import Brochure from "@/pages/Brochure";
import BrochureCorporate from "@/pages/BrochureCorporate";
import BrochureGym from "@/pages/BrochureGym";
import BrochureRealEstate from "@/pages/BrochureRealEstate";
import BrochureAthletes from "@/pages/BrochureAthletes";
import BrochureEquine from "@/pages/BrochureEquine";
import BrochurePets from "@/pages/BrochurePets";
import BrochureYacht from "@/pages/BrochureYacht";
import BrochureBvlgari from "@/pages/BrochureBvlgari";
import ThankYou from "@/pages/ThankYou";
import Live from "@/pages/Live";
import Watch from "@/pages/Watch";
import Sleep from "@/pages/Sleep";
import Plan from "@/pages/Plan";
import Session from "@/pages/Session";
import Investors from "@/pages/Investors";
import DapperDan from "@/pages/DapperDan";
import Resume from "@/pages/Resume";
import CoverLetter from "@/pages/CoverLetter";
import Application from "@/pages/Application";
import CoverLetterPortable from "@/pages/CoverLetterPortable";
import ApplicationPortable from "@/pages/ApplicationPortable";
import CoverLetterWynn from "@/pages/CoverLetterWynn";
import ApplicationWynn from "@/pages/ApplicationWynn";
import ApplicationWynnStage from "@/pages/ApplicationWynnStage";
import ApplicationWynnAutomation from "@/pages/ApplicationWynnAutomation";
import ApplicationTether from "@/pages/ApplicationTether";
import Reel from "@/pages/Reel";
import SunrisePitch from "@/pages/SunrisePitch";
import BotDashboard from "@/pages/BotDashboard";
import OdinDashboard from "@/pages/OdinDashboard";
import MidasPage from "@/pages/MidasPage";
import MidasReportPage from "@/pages/MidasReportPage";
import ApolloPage from "@/pages/ApolloPage";
import YatraPreviewPage from "@/pages/YatraPreviewPage";
import HeraPage from "@/pages/HeraPage";
import JanusPage from "@/pages/JanusPage";
import DfiPage from "@/pages/DfiPage";
import GtaxPage from "@/pages/GtaxPage";
import { GtaxErrorBoundary } from "@/components/gtax/GtaxErrorBoundary";
import { GTAX_HOST } from "@/components/gtax/base";
import DfiApply from "@/pages/DfiApply";
import DfiAdmin from "@/pages/DfiAdmin";
import DfiArjuna from "@/pages/DfiArjuna";
import DfiVeda from "@/pages/DfiVeda";
import DfiKubera from "@/pages/DfiKubera";
import DfiOrb from "@/pages/DfiOrb";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const STANDALONE_PATHS = ["/bot", "/quant", "/midas", "/report", "/apollo", "/yatra", "/odin", "/hera", "/janus", "/dfi", "/dfi/arjuna", "/dfi/veda", "/dfi/kubera", "/dfi/orb", "/dfi/apply", "/dfi/admin", "/gtax"];

const ConditionalChrome = ({ children }) => {
    const { pathname } = useLocation();
    const isStandalone = STANDALONE_PATHS.includes(pathname.replace(/\/+$/, "") || "/") || pathname.startsWith("/gtax");
    if (isStandalone) return null;
    return children;
};

function App() {
    if (GTAX_HOST) {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/*" element={<GtaxErrorBoundary><GtaxPage /></GtaxErrorBoundary>} />
                </Routes>
            </BrowserRouter>
        );
    }
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <PixelRouteTracker />
                <ConditionalChrome>
                    <Navigation />
                </ConditionalChrome>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/bot" element={<BotDashboard />} />
                    <Route path="/quant" element={<BotDashboard />} />
                    <Route path="/odin" element={<OdinDashboard />} />
                    <Route path="/midas" element={<MidasPage />} />
                    <Route path="/report" element={<MidasReportPage />} />
                    <Route path="/apollo" element={<ApolloPage />} />
                    <Route path="/yatra" element={<YatraPreviewPage />} />
                    <Route path="/hera" element={<HeraPage />} />
                    <Route path="/janus" element={<JanusPage />} />
                    <Route path="/dfi" element={<DfiPage />} />
                    <Route path="/gtax/*" element={<GtaxErrorBoundary><GtaxPage /></GtaxErrorBoundary>} />
                    <Route path="/dfi/arjuna" element={<DfiArjuna />} />
                    <Route path="/dfi/veda" element={<DfiVeda />} />
                    <Route path="/dfi/kubera" element={<DfiKubera />} />
                    <Route path="/dfi/orb" element={<DfiOrb />} />
                    <Route path="/dfi/apply" element={<DfiApply />} />
                    <Route path="/dfi/admin" element={<DfiAdmin />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/science" element={<Science />} />
                    <Route path="/book" element={<Book />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/refund" element={<Refund />} />
                    <Route path="/brochure" element={<Brochure />} />
                    <Route
                        path="/brochure-corporate"
                        element={<BrochureCorporate />}
                    />
                    <Route
                        path="/brochure-gym"
                        element={<BrochureGym />}
                    />
                    <Route
                        path="/brochure-realestate"
                        element={<BrochureRealEstate />}
                    />
                    <Route
                        path="/brochure-athletes"
                        element={<BrochureAthletes />}
                    />
                    <Route
                        path="/brochure-equine"
                        element={<BrochureEquine />}
                    />
                    <Route
                        path="/brochure-pets"
                        element={<BrochurePets />}
                      />
                      <Route
                        path="/brochure-yacht"
                        element={<BrochureYacht />}
                    />
                      <Route
                        path="/brochure-bvlgari"
                        element={<BrochureBvlgari />}
                    />
                    <Route
                        path="/thank-you"
                        element={<ThankYou />}
                    />
                    <Route
                        path="/live"
                        element={<Live />}
                    />
                    <Route
                        path="/watch"
                        element={<Watch />}
                    />
                    <Route path="/sleep" element={<Sleep />} />
                    <Route path="/session" element={<Session />} />
                    <Route path="/plan" element={<Plan />} />
                    <Route path="/investors" element={<Investors />} />
                    <Route path="/dapperdan" element={<DapperDan />} />
                    <Route path="/resume" element={<Resume />} />
                    <Route path="/cover-letter" element={<CoverLetter />} />
                    <Route path="/application" element={<Application />} />
                    <Route path="/cover-letter-portable" element={<CoverLetterPortable />} />
                    <Route path="/application-portable" element={<ApplicationPortable />} />
                    <Route path="/cover-letter-wynn" element={<CoverLetterWynn />} />
                    <Route path="/application-wynn" element={<ApplicationWynn />} />
                    <Route path="/application-wynn-stage" element={<ApplicationWynnStage />} />
                    <Route path="/application-wynn-automation" element={<ApplicationWynnAutomation />} />
                    <Route path="/application-tether" element={<ApplicationTether />} />
                    <Route path="/reel" element={<Reel />} />
                    <Route path="/sunrise-pitch" element={<SunrisePitch />} />
                </Routes>
                <ConditionalChrome>
                    <Footer />
                    <FloatingWhatsApp />
                    <CookieConsent />
                </ConditionalChrome>
            </BrowserRouter>
        </div>
    );
}

export default App;
